export default __webpack_public_path__ + "static/media/12.34a1e8df.png";